import { Injectable } from '@angular/core';
 import { HttpHeaders } from '@angular//common/http';
import { ErrorType } from './error-type.enum';
import { Error } from './error.model';
import { TokenService } from './token.service';
import { BehaviorSubject, Observable, Subject, throwError } from 'rxjs';
import { retry, catchError } from 'rxjs/operators';

@Injectable({providedIn:'root'})
export abstract class BaseService {
  protected tokenService: TokenService;

  constructor(tokenService: TokenService) {
    this.tokenService = tokenService;
  }

  // TODO: Add error handler and logging system into project
  handleError(error: any) {
    let errorMessage = '';
    if (error.error instanceof ErrorEvent) {
        // client-side error
        errorMessage = `Error: ${error.error.message}`;
    } else {
        // server-side error
        errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
    }
    //return throwError(errorMessage);
    return errorMessage;
}

  protected buildHeaders(): HttpHeaders {
    const token = this.tokenService.retrieve();
    const headers = new HttpHeaders();

    headers.set('Accept', 'application/json');
    headers.set('Content-Type', 'application/json');

    if (token.isAuthenticated) {
      headers.set('Authorization', `Bearer ${token.authToken}`);
    }

    headers.set('Access-Control-Allow-Origin', document.location.origin);

    return headers;
  }


  protected buildHeadersNew(): HttpHeaders {
    const token : any = this.tokenService.retrieve();
    let headers : any;
    if (token.isAuthenticated) {
      headers = new HttpHeaders().set('Accept', 'application/json').set('Authorization', `Bearer ${token.value.authToken}`).set('Accept', 'application/json');
    }
    return headers;
  }
  private date = new BehaviorSubject('default date');
  selectedDate = this.date.asObservable();

 public changeDate(date: string) {
    this.date.next(date)
    
  }

  public financialYear = new BehaviorSubject('default');
  selectedYear = this.financialYear.asObservable();

 public changeFinancialYear(year: any) {
  sessionStorage.setItem('financialYear',year)
    this.financialYear.next(year)
    
  }
  public getSelectedYear(){
    return this.selectedYear
  }
}
